import {Component, inject} from '@angular/core';
import {
  ColumnDef,
  DataTableComponent,
  TableActionEvent, TableStateEvent
} from "../../../shared/components/data-table/data-table.component";
import {BaseComponent} from "../../../shared/base/base-component";
import {State} from "../../../shared/base/base-state";
import {ButtonComponent} from "../../../shared/components/button/button.component";
import {CreateOrUpdateUserComponent} from "./create-or-update-user/create-or-update-user.component";
import {OverlayService} from "../../../shared/components/overlay/overlay.service";
import {GetAdminUserListItem, GetAdminUserListParams, GetAdminUserListResponse} from "../../../core/api/model";
import {ApiService} from "../../../core/api/api.service";
import {Constants} from "../../../core/constants/constants";
import {TableCellUserActionsComponent} from "../components/table-cell-user-actions/table-cell-user-actions.component";
import {TextInputComponent} from "../../../shared/inputs/text-input/text-input.component";


@Component({
  selector: 'app-users',
  imports: [
    DataTableComponent,
    DataTableComponent,
    ButtonComponent,
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent extends BaseComponent {

  apiService = inject(ApiService);
  overlayService = inject(OverlayService);

  getAdminUsersState = new State<GetAdminUserListResponse>();

  columnDefs: ColumnDef[] = [
    {title: 'Name', type: 'text', alignment: 'center', displayTemplate: '$firstName $lastName'},
    {title: 'Email', type: 'text', alignment: 'center', displayTemplate: '$email'},
    {title: 'Phone', type: 'text', alignment: 'center', displayTemplate: '$phoneNumber'},
    {title: 'Created Date', type: 'date', alignment: 'center', displayTemplate: '$createdDate'},
    {
      title: 'Status', type: 'badge', displayTemplate: '$isActive', badgeConfig: {
        properties: [
          {
            data: 'true',
            displayText: 'Enabled',
            indicatorColorClass: 'bg-success-500',
            backgroundColorClass: 'bg-success-50',
            borderColorClass: 'border-success-200',
            textColorClass: 'text-success-500'
          },
          {
            data: 'false',
            displayText: 'Disabled',
            indicatorColorClass: 'bg-error-500',
            backgroundColorClass: 'bg-error-50',
            borderColorClass: 'border-error-200',
            textColorClass: 'text-error-500'
          },
        ],

      },
    },
    {
      title: 'Actions', type: 'actions', actionsConfig: {
        iconActions: [{
          iconPath: "assets/icons/edit-fill.svg",
          actionKey: "edit", label: 'Update User'
        },
        ],
        components: [TableCellUserActionsComponent]
      },
    }
  ];

  getAdminUserList($event: TableStateEvent) {
    let request: GetAdminUserListParams = {
      pageNumber: $event.paginationEvent?.pageNumber,
      pageSize: $event.paginationEvent?.pageSize,
      search: $event.searchText
    }
    this.executeRequest({
      state: this.getAdminUsersState,
      request: this.apiService.getAdminUserList(request)
    });
  }

  onCreateNewUserClicked() {
    this.overlayService.openModal(CreateOrUpdateUserComponent).closed.subscribe((result) => {
      if (result) {
        this.getAdminUserList(Constants.defaultTableStateEvent);
      }
    });
  }

  onActionClicked($event: TableActionEvent) {
    let item: GetAdminUserListItem = $event.item;
    switch ($event.actionKey) {
      case 'edit':
        this.onEditClicked(item);
        break;
      case  'enableUser':
        this.getAdminUserList(Constants.defaultTableStateEvent);
        break;
      case 'disableUser':
        this.getAdminUserList(Constants.defaultTableStateEvent);
        break;
    }
  }

  onEditClicked(user: GetAdminUserListItem) {
    this.overlayService.openModal(CreateOrUpdateUserComponent, {
        data: user,
      }
    ).closed.subscribe(result => {
      if (result) {
        this.getAdminUserList(Constants.defaultTableStateEvent);
      }
    });
  }

}
